/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PurchaseItemType } from './PurchaseItemType';
import {
    PurchaseItemTypeFromJSON,
    PurchaseItemTypeFromJSONTyped,
    PurchaseItemTypeToJSON,
} from './PurchaseItemType';

/**
 * 
 * @export
 * @interface PurchaseDetail
 */
export interface PurchaseDetail {
    /**
     * 
     * @type {PurchaseItemType}
     * @memberof PurchaseDetail
     */
    purchaseItemType: PurchaseItemType;
    /**
     * 
     * @type {string}
     * @memberof PurchaseDetail
     */
    productId: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseDetail
     */
    additionalId?: string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseDetail
     */
    purchasableId: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseDetail
     */
    quantity: number;
}

/**
 * Check if a given object implements the PurchaseDetail interface.
 */
export function instanceOfPurchaseDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "purchaseItemType" in value;
    isInstance = isInstance && "productId" in value;
    isInstance = isInstance && "purchasableId" in value;
    isInstance = isInstance && "quantity" in value;

    return isInstance;
}

export function PurchaseDetailFromJSON(json: any): PurchaseDetail {
    return PurchaseDetailFromJSONTyped(json, false);
}

export function PurchaseDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'purchaseItemType': PurchaseItemTypeFromJSON(json['purchaseItemType']),
        'productId': json['productId'],
        'additionalId': !exists(json, 'additionalId') ? undefined : json['additionalId'],
        'purchasableId': json['purchasableId'],
        'quantity': json['quantity'],
    };
}

export function PurchaseDetailToJSON(value?: PurchaseDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'purchaseItemType': PurchaseItemTypeToJSON(value.purchaseItemType),
        'productId': value.productId,
        'additionalId': value.additionalId,
        'purchasableId': value.purchasableId,
        'quantity': value.quantity,
    };
}

